import { render, staticRenderFns } from "./WebifyImage.vue?vue&type=template&id=89dac890&scoped=true&"
import script from "./WebifyImage.vue?vue&type=script&lang=js&"
export * from "./WebifyImage.vue?vue&type=script&lang=js&"
import style0 from "./WebifyImage.vue?vue&type=style&index=0&id=89dac890&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89dac890",
  null
  
)

export default component.exports